/**
 * @module components.PublicProfiles.Facility.facilityBranding
 *
 * The public facility landing page has four branding variants, chosen purely by
 * which of the facility's two public images are set. See
 * .figma-design/CN-2652/spec.md for the frames.
 *
 *   banner + logo    logo straddles the banner's bottom edge, name below it
 *   banner, no logo  name sits directly below the banner
 *   logo, no banner  logo and name share one row on the page background
 *   neither          name alone on that row
 */
import { isEmpty } from 'app/utils';

// The API hands back a placeholder under this path rather than omitting the
// field, so a URL pointing into it means "this facility has no logo".
export const FALLBACK_LOGO_PATH = '/assets/fallback/logo/';

export const hasFacilityLogo = (logoUrl: string | undefined): boolean =>
  !isEmpty(logoUrl) && !logoUrl!.includes(FALLBACK_LOGO_PATH);

export const hasFacilityBanner = (coverUrl: string | undefined): boolean =>
  !isEmpty(coverUrl);
